import { Token, QuestsApi } from "@devour/client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { USE_GET_ALL_QUEST_CONFIGS_FOR_USER_KEY } from "./useGetAllQuestConfigsForUser";
import getConfig from "@/utils/getConfig";

interface RedeemCodeParams {
    code: string;
    questConfigId: string;
    milestoneId: string;
}

interface RedeemCodeResponse {
    success: boolean;
    message: string;
    milestoneComplete?: boolean;
    questComplete?: boolean;
}

interface _RedeemCodeError {
    message?: string;
    error?: string;
}

async function redeemCode(
    fullToken: Token,
    params: RedeemCodeParams,
): Promise<RedeemCodeResponse> {
    const data = await new QuestsApi(getConfig(fullToken)).createEventPipelineRedeemCode({
        redeemCodeBody: {
            code: params.code,
            questConfigId: params.questConfigId,
            milestoneId: params.milestoneId,
        },
    });
    return data as unknown as RedeemCodeResponse;
}

export function useRedeemCode(fullToken: Token) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ["redeem-code", fullToken?.id],
        mutationFn: (params: RedeemCodeParams) => redeemCode(fullToken, params),
        onSuccess: () => {
            // Invalidate quest progression queries to refresh milestone state
            queryClient.invalidateQueries({
                queryKey: [USE_GET_ALL_QUEST_CONFIGS_FOR_USER_KEY],
            });
        },
    });
}
